import React, { useCallback, useEffect, useState } from "react"
import LogsListTree from "./LogsListTree"
import LogsContent from "./LogsContent"
import { Divider } from "antd"
import { useSocket, useSocketEvent } from "../../../contexts/SocketContext"

const LogsTab = ({ activeTab }) => {
    const [content, setContent] = useState(null)
    const [treeData, setTreeData] = useState()
    const { isConnected, sendMessage } = useSocket()

    const logFilesTreeHandler = useCallback((res) => {
        setTreeData(res)
    }, [])

    const joinedHandler = useCallback(() => {
        sendMessage("getLogFilesTree")
    }, [])

    const logFileContentHandler = useCallback((payload) => {
        setContent(payload.content)
    }, [])

    useSocketEvent("logFilesTree", logFilesTreeHandler)
    useSocketEvent("userJoined", joinedHandler)
    useSocketEvent("logFileContent", logFileContentHandler)

    useEffect(() => {
        if (activeTab == "LogsTab") {
            console.log("Sending")
            sendMessage("joinLogsRoom")
        } else {
            sendMessage("disconnectLogsRoom")
        }
    }, [activeTab])

    return (
        <div
            style={{ direction: "ltr", height: "calc(100dvh - 210px)" }}
            className="grid grid-cols-6 grid-rows-1 gap-5 justify-between mx-5 settings"
        >
            <LogsListTree treeData={treeData} />
            <LogsContent content={content} />
        </div>
    )
}

export default LogsTab
